import { combineReducers } from '@reduxjs/toolkit';
import { configReducer } from 'shared/map-search/reducers/config';

import { activeFeatureReducer } from './activeFeature';
import { callPopupReducer } from './callPopup';
import { chatModalReducer } from './chatModal';
import { clustersTypeReducer } from './clustersType';
import { comparisonToastReducer } from './comparisonToast';
import { cpdReducer } from './cpd/reducer';
import { detailsVisiblePrecisionReducer } from './detailsVisiblePrecision';
import { drawingReducer } from './drawing';
import { earlyAccessContactsReducer } from './earlyAccessContacts';
import { experimentsReducer } from './experiments';
import { extendedQueryStringReducer } from './extendedQueryString';
import { featuresReducer } from './features';
import { filtersUrlReducer } from './filtersUrl';
import { fskBannerReducer } from './fskBanner';
import { infrastructureReducer } from './infrastructure';
import { isNewbuildingsListingReducer } from './isNewbuildingsListing';
import { lastActionReducer } from './lastAction';
import { listingUrlReducer } from './listingUrl';
import { mapBoundsReducer } from './mapBounds';
import { mapContainerAreaReducer } from './mapContainerArea';
import { mlSearchSessionGuidReducer } from './mlSearchSessionGuid';
import { newbuildingPromoFeaturesReducer } from './newbuildingPromoFeatures';
import { activeNewbuildingPolygonReducer, newbuildingsPolygonsReducer } from './newbuildingsPolygons';
import { nonGeoQueryStringReducer } from './nonGeoQueryString';
import { notificationsReducer } from './notifications';
import { offersCountReducer } from './offersCount';
import { parentRegionIdReducer } from './parentRegionId/parentRegionId';
import { platformReducer } from './platform';
import { promoInventoryReducer } from './promoInventory';
import { promoPinConfig } from './promoPinConfig';
import { queryStringReducer } from './queryString';
import { regionIdReducer } from './regionId';
import { resultsReducer } from './results';
import { rulerReducer } from './ruler';
import { searchResultsReducer } from './searchResults';
import { seoUrlReducer } from './seoUrl';
import { sourceReducer } from './source';
import { specialPromosReducer } from './specialPromos';
import { userReducer } from './user';
import { IApplicationState, TReduxActions } from '../types/redux';

export const reducer = combineReducers<IApplicationState, TReduxActions>({
  activeFeature: activeFeatureReducer,
  activeNewbuildingPolygon: activeNewbuildingPolygonReducer,
  callPopup: callPopupReducer,
  detailsVisiblePrecision: detailsVisiblePrecisionReducer,
  promoPinConfig,
  drawing: drawingReducer,
  comparisonToast: comparisonToastReducer,
  earlyAccessContacts: earlyAccessContactsReducer,
  experiments: experimentsReducer,
  extendedQueryString: extendedQueryStringReducer,
  features: featuresReducer,
  filtersUrl: filtersUrlReducer,
  isNewbuildingsListing: isNewbuildingsListingReducer,
  lastAction: lastActionReducer,
  infrastructure: infrastructureReducer,
  listingUrl: listingUrlReducer,
  mapBounds: mapBoundsReducer,
  newbuildingPromoFeatures: newbuildingPromoFeaturesReducer,
  newbuildingsPolygons: newbuildingsPolygonsReducer,
  nonGeoQueryString: nonGeoQueryStringReducer,
  notifications: notificationsReducer,
  cpd: cpdReducer,
  offersCount: offersCountReducer,
  promoInventory: promoInventoryReducer,
  queryString: queryStringReducer,
  regionId: regionIdReducer,
  parentRegionId: parentRegionIdReducer,
  results: resultsReducer,
  ruler: rulerReducer,
  searchResults: searchResultsReducer,
  seoUrl: seoUrlReducer,
  specialPromos: specialPromosReducer,
  fskBanner: fskBannerReducer,
  user: userReducer,
  platform: platformReducer,
  config: configReducer,
  chatModal: chatModalReducer,
  clustersType: clustersTypeReducer,
  mapContainerArea: mapContainerAreaReducer,
  source: sourceReducer,
  mlSearchSessionGuid: mlSearchSessionGuidReducer,
});
